// extracted by mini-css-extract-plugin
module.exports = {"ActiveList":"ActiveList_ActiveList__1S7Gs","NoTasksMessage":"ActiveList_NoTasksMessage__2VL5_"};